import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type FaqCreateInitValuesType = {
    title: string;
    isVisible: boolean;
    mainCategory: string;
    middleCategory: string;
    content: string;
};

export type FaqCommonContentsOptionType = {
    placeholder?: string;
    notice?: JSX.Element;
} & CommonContentsRenderType;

export const FaqCreateData: CommonDataType<CommonCreateBodyKeyType, FaqCreateInitValuesType> = {
    createBodyKey: ["isVisible", "mainCategory", "middleCategory", "title", "content"],
    formInitialValues: {
        title: "",
        isVisible: false,
        mainCategory: "",
        middleCategory: "",
        content: "",
    },
};
